import { BaseModel } from '@red/data-access';
import { Expose, Type } from 'class-transformer';

export class NoReminderCreateDto extends BaseModel {
  @Expose()
  @Type(() => Number)
  agentId!: number;

  @Expose()
  @Type(() => Boolean)
  isActive!: boolean;
}

export class NoReminderUpdateDto extends BaseModel {
  @Expose()
  @Type(() => Number)
  agentId!: number;

  @Expose()
  @Type(() => Boolean)
  isActive!: boolean;
}
